import { createFileRoute, Link } from "@tanstack/react-router";
import { AiPromptButton } from "../../components/AiPrompt";

export const Route = createFileRoute("/docs/")({
  component: Overview,
});

function Overview() {
  return (
    <>
      <h1>Overview</h1>
      <p className="lead">
        notify is a hosted browser-push primitive. You embed one script, call one function, and your
        users get native notifications — no Firebase account, no VAPID keys, no service worker
        boilerplate.
      </p>

      <div className="ai-box">
        <div className="ai-copy">
          <h3>Let your AI wire it up</h3>
          <p>Copy a ready-made prompt and paste it into Cursor, Claude, or ChatGPT.</p>
        </div>
        <AiPromptButton />
      </div>

      <h2>The mental model</h2>
      <p>There are exactly two surfaces, and they share one project:</p>
      <ul>
        <li>
          <strong>notify.js</strong> runs in your user’s browser with your{" "}
          <strong>publishable</strong> key. It manages permission and the push subscription. It never
          sends notifications.
        </li>
        <li>
          <strong>Your backend</strong> calls <span className="icode">POST /send</span> with your{" "}
          <strong>secret</strong> key, a user id, and a message. The secret key stays server-side.
        </li>
      </ul>

      <div className="callout">
        Anonymous-first: <span className="icode">npx notify-dev init</span> mints a project (a
        publishable + secret key pair) with no account.
      </div>

      <h2>Where to go next</h2>
      <ul>
        <li>
          <Link to="/docs/quickstart" className="ilink">
            Quickstart
          </Link>{" "}
          — the 60-second loop, end to end.
        </li>
        <li>
          <Link to="/docs/how-it-works" className="ilink">
            How it works
          </Link>{" "}
          — the architecture and the push protocol.
        </li>
        <li>
          <Link to="/docs/api-reference" className="ilink">
            API reference
          </Link>{" "}
          — every endpoint you can touch.
        </li>
        <li>
          Framework guides:{" "}
          <Link to="/docs/nextjs" className="ilink">
            Next.js
          </Link>{" "}
          ·{" "}
          <Link to="/docs/tanstack-start" className="ilink">
            TanStack Start
          </Link>
        </li>
      </ul>

      <div className="doc-foot">
        <span />
        <Link to="/docs/quickstart" className="ilink">
          Quickstart →
        </Link>
      </div>
    </>
  );
}
